"use client";

import { cn } from "@/utils/utils";
import { useSearchParams } from "next/navigation";
import useGetSearchParams from "@/lib/hooks/useGetSearchParams";

import { FilterProduct } from "@/types/Product.type";
import { SortByData, sortByDataProduct } from "@/common/constants/product";

const ProductFilterSortBy = ({
  onFilter,
}: {
  onFilter: (filter: FilterProduct) => void;
}) => {
  const searchParams = useSearchParams();
  const filters: any = useGetSearchParams();
  const sortByDe = searchParams.get("sort_by");
  const sorttype = searchParams.get("sort_type");

  const checkIsActive = (item: SortByData) => {
    if (item.sort_type === sorttype && item.sort_by === sortByDe) {
      return true;
    }
    return false;
  };

  return (
    <ul className="border-t border-gray-300">
      {sortByDataProduct.map((item, index) => {
        return (
          <li
            key={index}
            className={cn(
              `py-1 border-b border-gray-300 h-[50px] flex items-center justify-center`,
              {
                "font-bold text-red-500": checkIsActive(item),
              }
            )}
            onClick={() => {
              if (checkIsActive(item)) {
                return;
              } else {
                onFilter({
                  ...filters,
                  sort_by: item.sort_by,
                  sort_type: item.sort_type,
                  page: 1,
                });
              }
            }}
          >
            <span className="w-full h-full flex items-center justify-center text-base">
              {item.name}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default ProductFilterSortBy;
